import React from 'react'
import DataGrid, {
  ColumnChooser,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Export,
  Selection,
  SearchPanel,
  Editing,
  Column,
  Button,
  Pager,
  Paging,
  LoadPanel
} from "devextreme-react/data-grid";
import { useNavigate } from 'react-router-dom';
import { FormateoFechaPara_yyyyMMdd, TratamientoDeParametroParaURI } from 'neftis7_apicaller/src/funciones/Varios';
import { Row } from 'devextreme-react/responsive-box';

export const LVGridCabecera = (props) => {
  let { dataSource, id, keyExpr, keyExpr2, keyExpr3, urlEdicion, AnchoBotonera,
    children, onClickPrint, onClickClone, onClickEnviarEmail, PageSize = 13,
    puedeEditar = true, puedeImprimir = true, puedeMail = true, puedeClonar = false } = props;
  const navigate = useNavigate();

  const handleOnClickEdit = (e) => {
    const Item = { ...e.row.data };

    if (keyExpr2 && keyExpr2.toLowerCase().startsWith("fecha")) {
      // Verificar si el valor existe antes de convertirlo
      if (Item[keyExpr2]) {
        Item[keyExpr2] = FormateoFechaPara_yyyyMMdd(new Date(Item[keyExpr2]));
      }
    }

    if (keyExpr3 && keyExpr3.toLowerCase().startsWith("fecha")) {
      // Verificar si el valor existe antes de convertirlo
      if (Item[keyExpr3]) {
        Item[keyExpr3] = FormateoFechaPara_yyyyMMdd(new Date(Item[keyExpr3]));
      }
    }

    let url = urlEdicion + "/" + TratamientoDeParametroParaURI(Item[keyExpr])
    if (keyExpr2 && keyExpr2 !== "") {
      url = url + "/" + Item[keyExpr2]
    }
    if (keyExpr3 && keyExpr3 !== "") {
      url = url + "/" + Item[keyExpr3]
    }
    navigate(url)
  };

  const handleOnClickClone = (e) => {

    const Item = { ...e.row.data };

    if (onClickPrint) {
      onClickClone(Item);
    }
  };

  const handleOnClickPrint = (e) => {

    const Item = { ...e.row.data };

    if (onClickPrint) {
      onClickPrint(Item);
    }
  };

  const handleOnClickEnviarEMail = (e) => {

    const Item = { ...e.row.data };

    if (onClickEnviarEmail) {
      onClickEnviarEmail(Item);
    }
  };

  return (
    <DataGrid
      dataSource={dataSource}
      style={{ fontSize: '11px', fontFamily: 'Tahoma, sans-serif' }}
      showRowLines={true}
      showBorders={true}
      allowColumnResizing={true}
      id={id}
      keyExpr={keyExpr}
      rowAlternationEnabled={true}
      urlEdicion={urlEdicion}
    >
      <HeaderFilter visible={true} />
      <FilterPanel visible={true} />
      <FilterRow visible={true} />
      <Selection mode="multiple" />
      <Export enabled={true} allowExportSelectedData={true} />
      <SearchPanel visible={true} />
      <LoadPanel enabled={true} />

      <ColumnChooser enabled="True" mode="select" />
      <Editing
        mode="popup"
        useIcons={true}
        allowAdding={false}
      />
      {/* <Popup title="Employee Info" showTitle={true} width={700} height={525} />   */}
      <Column type="buttons" name="EditarClonar" width={AnchoBotonera}>
        <Button name="Editar" icon="edit" onClick={handleOnClickEdit} visible={puedeEditar} />
        <Button name="Clonar" icon="copy" onClick={handleOnClickClone} visible={puedeClonar} />
        <Button name="Imprimir" icon="print" onClick={handleOnClickPrint} visible={puedeImprimir} />
        <Button name="EMail" icon="message" onClick={handleOnClickEnviarEMail} visible={puedeMail} />
      </Column>

      {children}

      <Paging defaultPageSize={PageSize} />
      <Pager
        showPageSizeSelector={false}
      />
    </DataGrid>
  );
}